import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Auth from "./components/Auth";
import Dashboard from "./components/Dashboard";
import VerifyEmail from "./components/VerifyEmail";
import InvitePage from "./components/InvitePage";
import NotificationProvider from "./components/NotificationProvider";

import "./styles/theme.css";

function App() {
  return (
    <Router>
      <NotificationProvider>
        <Routes>
          <Route path="/" element={<Auth />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/invite" element={<InvitePage />} />
        </Routes>
      </NotificationProvider>
    </Router>
  );
}

export default App;
